import { useMyUser } from "../../User/hooks/useMyUser";
import { useLocalStorage } from "./useLocalStorage";

export const useIsAdminInterface = () => {
  const isAdminInLocalStorage = useLocalStorage((state) => state.data.isAdmin);
  const isUserRoleAdmin = useMyUser((state) => state.user?.role === "ADMIN");

  return isUserRoleAdmin && isAdminInLocalStorage;
};
